/**
 * Transform function for getOrderHistory method
 * Flattens all nested nodes and edges structures from GraphQL response
 * Receives validated customer data from service layer
 */
export function mapGetOrderHistoryToResponse(customerData: any) {
  const orders =
    customerData.orders?.nodes?.map((order: any) => ({
      ...order,
      // Flatten lineItems - convert from nodes or edges/node to direct array
      lineItems:
        order.lineItems?.nodes ||
        order.lineItems?.edges?.map((edge: any) => edge.node) ||
        [],
    })) || [];

  return {
    ...customerData,
    orders,
  };
}

/**
 * Transform function for getOrderById method
 * Flattens nested lineItems nodes/edges structures from GraphQL response
 * Receives validated order data from service layer
 */
export function mapGetOrderByIdToResponse(orderData: any) {
  return {
    ...orderData,
    // Flatten lineItems - convert from nodes or edges/node to direct array
    lineItems:
      orderData.lineItems?.nodes ||
      orderData.lineItems?.edges?.map((edge: any) => edge.node) ||
      [],
  };
}

/**
 * Transform function for getCustomerProfile method
 * Flattens nested addresses nodes/edges structures from GraphQL response
 * Receives validated customer data from service layer
 */
export function mapGetCustomerProfileToResponse(customerData: any) {
  return {
    ...customerData,
    // Flatten addresses - convert from nodes or edges/node to direct array
    addresses:
      customerData.addresses?.nodes ||
      customerData.addresses?.edges?.map((edge: any) => edge.node) ||
      [],
  };
}
